import { render, staticRenderFns } from "./ModuleQuotation.vue?vue&type=template&id=34cbbce8&scoped=true&"
import script from "./ModuleQuotation.vue?vue&type=script&lang=js&"
export * from "./ModuleQuotation.vue?vue&type=script&lang=js&"
import style0 from "./ModuleQuotation.vue?vue&type=style&index=0&id=34cbbce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbbce8",
  null
  
)

export default component.exports